
import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MbscModule } from '@mobiscroll/angular';
import { categoryData, operatingTimeData, statusData, taskType } from '../../../../interfaces/selectData';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { BacklogFilterService } from '../../../../services/shared/filter/backlog-filter.service';
import { FormsModule } from '@angular/forms';
import { getPopupButtonsBacklogFilter, popupOptions, sliderOptions } from '../../../../interfaces/popup-buttons/filter/popup-options';

@Component({
  selector: 'app-filter-backlog-popup',
  imports: [MbscModule, FormsModule, NgxSliderModule],
  templateUrl: './filter-backlog-popup.component.html',
  styleUrl: './filter-backlog-popup.component.scss'
})
export class FilterBacklogPopupComponent {
  @ViewChild('backlogFilterButton', { static: false }) backlogFilterButton!: ElementRef;
  @ViewChild('backlogFilterPopup', { static: false }) backlogFilterPopup: any;

  @Input() tasks: any[] = [];
  @Output() filteredTasksChange = new EventEmitter<any[]>();

  popupAnchorBacklogFilter: HTMLElement | null = null;

  searchTitle: string = '';
  searchLocation: string = '';
  searchCustomer: string = '';
  searchStatus: any;
  searchCategory: any;
  searchOperatingTime: any;
  searchTaskType: any;
  searchOnline: any;
  searchStartTime: any;
  searchEndTime: any;

  statusData = statusData;
  categoryData = categoryData;
  operatingTimeData = operatingTimeData;
  taskType = taskType;

  minDuration: number = 1;
  maxDuration: number = 15;

  filter: any;
  filteredTasks: any[] | null = null;

   public popupOptions = popupOptions;
   public sliderOptions = sliderOptions;
   popupButtonsBacklogFilter = getPopupButtonsBacklogFilter(() => this.resetFilter());

  constructor(private BacklogFilterService: BacklogFilterService) {}

  openBacklogFilter(popupAnchor: any) {
    this.popupAnchorBacklogFilter = popupAnchor;
    this.backlogFilterPopup.open();
  }

  resetFilter() {
    this.searchTitle = '';
    this.searchLocation = '';
    this.searchStatus = [];
    this.searchCategory = [];
    this.searchOperatingTime = [];
    this.searchTaskType = [];
    this.searchOnline = undefined;
    this.searchStartTime = undefined;
    this.searchEndTime = undefined;
    this.minDuration = 1;
    this.maxDuration = 15;

    this.filteredTasks = [...this.tasks]; 
    this.filteredTasksChange.emit(this.filteredTasks);
  }

  applyBacklogFilter() {
    // Warten bis tasks definiert ist (nicht undefined oder null)
    if (this.tasks === undefined || this.tasks === null) {
      console.warn('applyBacklogFilter: tasks ist noch nicht geladen');
      return;
    }

    this.filter = {
      searchTitle: this.searchTitle,
      searchLocation: this.searchLocation,
      searchStatus: this.searchStatus || [],
      searchCategory: this.searchCategory || [],
      searchOperatingTime: this.searchOperatingTime || [],
      searchTaskType: this.searchTaskType || [],
      searchOnline: this.searchOnline,
      searchStartTime: this.searchStartTime,
      searchEndTime: this.searchEndTime,
      minDuration: this.minDuration,
      maxDuration: this.maxDuration
    };

    this.filteredTasks = this.tasks.length
      ? this.BacklogFilterService.filterTasks(this.tasks, this.filter)
      : [];

    this.filteredTasksChange.emit(this.filteredTasks);
  }
}

